import React from 'react';
import {
  Paper,
  Typography,
  withStyles,
} from '@material-ui/core';
import styles from './styles';
import { Loading } from '../../components/common';

const EntraIdWindowsData = props => {
  const {
    classes,
    loading,
    values,
  } = props;

  return (
    <div>
      <Paper elevation={2} className={classes.root}>
        <div className={classes.formHeader}>
          <div className={classes.titleContainer}>
            <Typography style={{ fontSize: 20 }}>Perfil</Typography>
            <span style={{color: "#a9a9a9", fontWeight: 'bold'}}>Provisto por Entra ID</span>
          </div>
        </div>
        {loading ? (
          <Loading />
        ) : (
          <div style={{padding:'1.5rem'}}>
            <p><b>Nombre:</b> {values.name}</p>
            <p><b>Mail:</b> {values.preferredUsername}</p>
            <h3>Grupos asignados</h3>
            <ul>
              {values.groups != undefined && values.groups.map(group => <li key={group}>{group}</li>)}
            </ul>
          </div>
        )}
      </Paper>
    </div>
  );
};

export default withStyles(styles)(EntraIdWindowsData);
